import { useMutation } from "react-query";
import useNetworkHeaders from "../../../hooks/useNetworkHeaders";
import { postCitizenCrmRequest } from "../../../queries/citizen";

export default function useCreateCitizenCrmRequest() {
  const networkHeaders = useNetworkHeaders();

  const [createCrmRequestMutation, createCrmRequestMutationState] = useMutation(postCitizenCrmRequest(networkHeaders));

  return {
    isLoading: createCrmRequestMutationState.isLoading,
    createCrmRequest: async (
      {
        description,
        classificationName,
      }: {
        description: string;
        classificationName: string;
      },
      { onSuccess, onError }: { onSuccess?: (data: any) => void; onError?: (err: unknown) => void } = {
        onSuccess: () => {},
        onError: () => {},
      },
    ): Promise<{ id: string; displayId: string }> => {
      return createCrmRequestMutation(
        {
          description: description,
          mobileType: 0,
          devicePlatform: "Web",
          topic: {
            name: classificationName,
          },
        },
        { onSuccess: onSuccess, onError: onError },
      );
    },
  };
}
